import { V2 } from 'engine/lib/V2';

export const FEEDBACK_URL = 'https://forms.gle/qhScyGvvWvyPuuxG9';

export enum CollisionLayer {
  Hitbox = 0b001,
  Door = 0b010,
  Wall = 0b100,
}

export const MAX_BOT_HP = 200;
export const MAX_NEARBY_DISTANCE = 1000;
export const MAX_LASER_RANGE = 800;

interface Rect { offset: V2, size: V2 }

export const concreteMap: Rect[] = [
  { offset: [700, 3400], size: [2200, 500] },
  { offset: [0, 4600], size: [10440, 470] },
  { offset: [7960, 3210], size: [440, 1340] },
  { offset: [7430, 2300], size: [1500, 970] },
];

export const grassMap: Rect[] = [
  { offset: [0, 0], size: [10440, 6000] },
  { offset: [0, -5000], size: [520, 690] },
];

export const pointInRect = ([x, y]: V2, { offset: [left, top], size: [w, h] }: Rect): boolean => {
  return (x > left && x < left + w)
    && (y > top && y < top + h);
};
